import createTheme from '@/themes/createTheme.ts'

const theme = {
  mainColor: '#D9001B', // 主题色 #13655B 绿色
  visionColor: '#fffbe6', // 主题 衍生色  按钮背景  hover等效果
  rowSelectedHoverBg: '#fff1b8', // 主题 衍生色  按钮背景  hover等效果
  headerIconBorder: '#ffe58f', //  导航图标边框
  headerIconBg: '#ffc53d', //  导航图标背景
}

export default createTheme(theme)
